import React, { useState, useMemo, useEffect } from "react";
import styles from "./styles.module.scss";
import Setting from "@assets/icons/setting";
import FinanceFlowChart from "../../../../components/FinanceFlowChart";
import { SettingsModal } from "../InventoryPerformance/modal";
import { ExpandableTable } from "@components/ExpandebleTable";
import { useTimeRangeStore } from "src/store/daily-week";
import { useDashboardStore } from "@pages/Dashboard/store/dashboard.state";
import { formatTableData } from "./utils";
import { CfoApi } from "@services/cfo/cfo.api";

interface CashBlocksProps {
  setHideFinance?: (hide: boolean) => void;
  hideFinance?: boolean;
}

const CashBlocks: React.FC<CashBlocksProps> = ({
  setHideFinance,
  hideFinance,
}) => {
  const cfoApi = useMemo(() => new CfoApi(), []);
  const [isLoading, setIsLoading] = useState(false);
  const { asinSelected, dateRange } = useDashboardStore();
  const { timeRange } = useTimeRangeStore();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [dataPoints, setDataPoints] = useState<Record<string, boolean>>({
    amazon_ad_sales: true,
    amazon_organic_sales: true,
    tiktok_sales: true,
    shopify_sales: true,
    amazon_cogs: true,
    tiktok_cogs: true,
    shopify_cogs: true,
    amazon_fees: true,
    ad_spend: true,
    other_fees: true,
    tiktok_cost: true,
    shopify_cost: true,
    amazon_opex: true,
    tiktok_opex: true,
    shopify_opex: true,
    cash_flow: true,
  });
  const [tableData, setTableData] = useState<any[]>([]);
  const [tableColumns, setTableColumns] = useState<any[]>([]);
  const [showForecast, setShowForecast] = useState(false);
  const [isPoModal, setIsPoModal] = useState(false);
  const [isTableView, setIsTableView] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dateStartString = dateRange.startDate.toISOString().split("T")[0];
        const dateEndString = dateRange.endDate.toISOString().split("T")[0];

        const response = await cfoApi.getCashFlowTableData({
          startDate: dateStartString,
          endDate: dateEndString,
          asin: asinSelected.length > 0 ? asinSelected[0] : "",
          period: timeRange,
        });

        const formattedData = formatTableData(response, dataPoints);
        console.log("Formatted Finance Data:", formattedData);
        setTableData(formattedData.data);
        setTableColumns(formattedData.columns);
      } catch (error) {
        console.error("Error fetching finance data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dataPoints, isTableView, asinSelected, dateRange, timeRange, cfoApi]);

  return (
    <div className={styles.perfomanceBlock}>
      <div className={styles.marketPerformanceWrapper}>
        {isTableView ? (
          <div className={styles.cashTable}>
            <h2 className={styles.cashTitle}>Profit and Loss Statement</h2>
            <ExpandableTable
              data={tableData}
              columns={tableColumns}
              scroll={{ y: 600 }}
              className={styles.cashFlowTable}
              isLoading={isLoading}
            />
          </div>
        ) : (
          <FinanceFlowChart
            showForecast={showForecast}
            title={true}
            dataPoints={dataPoints}
            timeRange={timeRange}
            asin={asinSelected[0]}
            dateRange={dateRange}
          />
        )}
        <div className={styles.settings}>
          <button
            className={styles.hide}
            onClick={() => setHideFinance(!hideFinance)}
          >
            {!hideFinance
              ? "Show Financial Overview"
              : "Hide Financial Overview"}
          </button>
          <button
            className={styles.setting__button}
            onClick={() => setIsOpenModal(true)}
            aria-label="Settings"
          >
            <Setting />
          </button>
        </div>
      </div>
      <SettingsModal
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        setDataPoints={setDataPoints}
        dataPoints={dataPoints}
        showForecast={showForecast}
        setShowForecast={setShowForecast}
        isPoModal={isPoModal}
        setIsPoModal={setIsPoModal}
        isCash={true}
        isTableView={isTableView}
        setIsTableView={setIsTableView}
      />
    </div>
  );
};

export default CashBlocks;
